var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-light icon-btn",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close","data-test":"close-button"}},[_c('i',{staticClass:"fas fa-times"})])
}]

export { render, staticRenderFns }